// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Fh7f","label":"Section_label__ViE_w","contentWrap":"Section_contentWrap__2YOVm","footer":"Section_footer__2yup3","footerInner":"Section_footerInner__Xdeys"};